<template>
  <v-container fluid>
    <v-data-table class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="headers" :items="Declarations"
      :items-per-page="5">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des déclarations sinistres</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb" @change="showAllFillData"
            class="pt-5"></v-switch>
          <v-spacer></v-spacer>

          <!--  Déclaration sinistre-->
          <template>
            <div>
              <v-row justify="center">
                <v-dialog v-model="sinisterDialog" overlay transition="dialog-bottom-transition" scrollable
                  max-width="1000px">
                  <v-card style="border-top: 10px solid #0482fb">
                    <v-card-text>
                      <h2 class="pt-8 pl-3">informations de la déclaration</h2>
                      <v-container fluid>
                        <v-row align="center">
                          <!-- <v-col cols="12" sm="3">
                      <v-text-field outlined  
            color="#0482fb"
                        v-model="sinisterAskNumber"
                        label="Numéro sinistre DAYO"
                      ></v-text-field>
                    </v-col> -->
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.sinisterCompanyNumber"
                              label="Numéro sinistre compagnie"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.dateOfOccurrence"
                              type="date" required :rules="[(v) => !!v || 'Required']"
                              label="Date de survenance"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.declarationDate"
                              type="date" label="Date déclaration"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.companyDispatchDate"
                              type="date" label="Date envoi compagnie"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.driverName"
                              label="Nom conducteur"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.conductiveContact"
                              label="Contact conducteur"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="
                              declarationModal.registrationValidationDate
                            " type="date" label="Date retour compagnie"></v-text-field>
                          </v-col>

                          <v-col cols="12" md="12">
                            <v-textarea outlined v-model="declarationModal.circumstance" name="input-7-4"
                              label="Circonstance du sinistre" value=""></v-textarea>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" disabled v-model="declarationModal.PSAP"
                              label="PSAP"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.disasterObject"
                              label="Objet sinistré"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.materialDamageInsured"
                              label="Dommage matériels assuré"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-text-field outlined color="#0482fb" v-model="declarationModal.insuredBodilyInjury"
                              label="Dommage corporels assuré"></v-text-field>
                          </v-col>

                          <v-col cols="12" md="12">
                            <v-textarea outlined v-model="declarationModal.observation" name="input-7-4"
                              label="Renseignements Tiers" value=""></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-row justify="end">
                        <v-btn text color="error" @click="sinisterDialog = false">
                          Fermer
                        </v-btn>
                        <v-btn tile color="success" class="ml-5" @click="saveDeclaration">
                          Enregistrer
                        </v-btn>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-row>
            </div>
          </template>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Etes vous sûrs de vouloire supprimer cet élément
                ?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date survenance debut ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="startDate" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date survenance fin..." class="pt-5 pa-2" type="date"
                      prepend-inner-icon="mdi-magnify" dense v-model="endDate" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Numéro sinistre DAYO..." class="pt-5 pa-2"
                      v-model="sinisterAskNumber" prepend-inner-icon="mdi-magnify" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Numéro sinistre compagnie..." class="pt-5 pa-2"
                      v-model="sinisterCompanyNumber" prepend-inner-icon="mdi-magnify" dense flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete outlined color="#0482fb" :items="userFile" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat background-color="grey lighten-4"
                      label="Nom raison social">
                    </v-autocomplete>

                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="company" flat background-color="grey lighten-4" label="Compagnie ..."></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon color="warning" class="mr-2" @click="editItem(item)">
          mdi-pencil-box-multiple-outline
        </v-icon>
        <v-btn class="ml-5" icon :to="`/sinistre/${item._id}`">
          <v-icon size="30" color="success">mdi-arrow-right-circle-outline</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.name="{ item }">
        <td>
          {{ item.contract.file.name }}
        </td>
      </template>
      <template v-slot:item.product="{ item }">
        <td>
          {{ item.contract.product }}
        </td>
      </template>
      <template v-slot:item.category="{ item }">
        <td>
          {{ item.contract.category }}
        </td>
      </template>
      <template v-slot:item.driverName="{ item }">
        <td>
          {{
            item.contract.company && item.contract.company.name
              ? item.contract.company.name
              : ""
          }}
        </td>
      </template>
      <template v-slot:item.policeNumber="{ item }">
        <td>
          {{ item.contract.policeNumber }}
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { updateDeclaration } from "@/api/user.js";
export default {
  name: "production",
  components: {},
  data: () => ({
    dialog: false,
    companyNameList: [],
    productNameList: [],
    sinisterDialog: false,
    dialogDelete: false,
    fileName: "",
    product: "",

    sinisterAskNumber: "",
    sinisterCompanyNumber: "",
    startDate: "",
    endDate: "",
    company: "",
    loading: false,
    headers: [
      {
        text: "Actions",
        width: "200px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      {
        text: "N° sinistre DAYO",
        width: "200px",
        align: "start",
        sortable: false,
        value: "sinisterAskNumber",
      },
      {
        text: "N° sinistre compagnie",
        width: "200px",
        value: "sinisterCompanyNumber",
      },
      { text: "Nom client", width: "200px", value: "name" },
      { text: "Produit", width: "200px", value: "product" },
      { text: "Catégorie", width: "200px", value: "category" },
      { text: "Date suvenance", width: "200px", value: "dateOfOccurrenceFr" },
      { text: "Date déclaration", width: "200px", value: "declarationDateFr" },
      {
        text: "Date envoi compagnie",
        width: "200px",
        value: "companyDispatchDateFr",
      },
      { text: "Compagnie", width: "200px", value: "driverName" },
      { text: "N° police", width: "200px", value: "policeNumber" },
      { text: "Circonstance", width: "200px", value: "circumstance" },
      // { text: "Statut", value: "protein" },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    declarationModal: {},
  }),

  computed: {
    ...mapGetters(["Declarations", "Companies", "Products", "Files",]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      // this.seedCoinsuranceCompanyNameList();
    },
    Products() {
      // alert('ok')
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions([
      "getDeclarations",
      "getDeclarationSearch",
      "getProducts",
      "getCompanies",
      "getFiles",
    ]),
    showAllFillData() {
      this.initialize();
      //alert(this.showAllFil);
    },
    async makeSearchContract() {
      this.loading = true;
      //alert("ok");
      try {
        await this.getDeclarationSearch({
          fileName: defaultMethods.getItemId(this.Files.docs, this.fileName),
          product: this.product,
          sinisterAskNumber: this.sinisterAskNumber,
          sinisterCompanyNumber: this.sinisterCompanyNumber,
          startDate: this.startDate,
          endDate: this.endDate,
          company: this.company,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les sinistres")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      this.makeSearchContract();
    },
    async initialize() {
      this.loading = true;
      try {
        await this.getDeclarations({ withoutPeriod: this.showAllFil });
        await this.getCompanies();
        await this.getFiles({ withoutPeriod: true });
        await this.getProducts({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    editItem(item) {
      this.editedIndex = 1;
      this.declarationModal = Object.assign({}, item);
      this.sinisterDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.declarationModal = Object.assign({}, this.declarationModal);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.declarationModal);
        this.editedIndex = -1;
      });
    },

    async saveDeclaration() {
      this.loading = true;

      try {
        const schema = {
          sinisterCompanyNumber: this.declarationModal.sinisterCompanyNumber,
          dateOfOccurrence: this.declarationModal.dateOfOccurrence,
          declarationDate: this.declarationModal.declarationDate,
          companyDispatchDate: this.declarationModal.companyDispatchDate,
          driverName: this.declarationModal.driverName,
          conductiveContact: this.declarationModal.conductiveContact,
          registrationValidationDate: this.declarationModal
            .registrationValidationDate,
          PSAP: this.declarationModal.PSAP,
          disasterObject: this.declarationModal.disasterObject,
          materialDamageInsured: this.declarationModal.materialDamageInsured,
          insuredBodilyInjury: this.declarationModal.insuredBodilyInjury,
          circumstance: this.declarationModal.circumstance,

          observation: this.declarationModal.observation,
        };

        // add
        await updateDeclaration({ schema, id: this.declarationModal._id });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Declaration")
        );
        this.closeDeclaration();
        this.initialize();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeDeclaration() {
      this.declarationModal = {};
      this.sinisterDialog = false;
      // this.currentProduct = null;
    },
  },
};
</script>

<style scoped>

</style>
